import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { ConnectorConfig, DataConnector } from "@pufflig/prompt-studio-types";
import { integrationData } from "../constants";

export const createConnector = async (connector: DataConnector<ConnectorConfig>, teamId?: string): Promise<string> => {
  const { name, description, config } = connector;
  const { type, ...settings } = config;
  const ownerId = teamId || (await getUserId());

  let p_config: Record<string, string | null> = { ...settings };

  const { data, error } = await supabase.rpc("create_connector", {
    p_name: name,
    p_description: description || "",
    p_type: type,
    p_config,
    owner_id: ownerId,
  });

  if (error) {
    throw new Error(`Error creating ${integrationData[type].title} connector: ${error.message}`);
  }

  return data;
};
